<template>
  <div>
    <v-container container--fluid grid-list-xl>
      <v-row align="center">
        <v-col cols="12" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
          <h1>Excel reports </h1>
        </v-col>
      </v-row>
      <v-tabs v-model="tab" grow>
        <v-tab key="error">
          <v-icon class="mr-2">fas fa-exclamation-triangle</v-icon> Error
        </v-tab>
        <v-tab key="canceledDeleted">
          <v-icon class="mr-2">fas fa-times</v-icon> Cancel/Delete
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item key="error">
          <ErrorReportPage></ErrorReportPage>
        </v-tab-item>
        <v-tab-item key="canceledDeleted">
          <DelCanReportPage></DelCanReportPage>
        </v-tab-item>
      </v-tabs-items>

    </v-container>
  </div>
</template>

<script>
  import ErrorReportPage from "./ExcelReports/ErrorReportPage";
  import DelCanReportPage from "./ExcelReports/DelCanReportPage";

  export default {
    name: "ExcelReportsPage",
    components: {ErrorReportPage, DelCanReportPage},
    data () {
      return {
        tab: 0,
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/ExcelReportsPage.vue